<template>
    <div class="ticket_help_chat_popup">
        <div class="bot_ticket_popup">
            <div class="bot_ticket_popup_center">
                <div class="bot_ticket_popup_modal">
                    <div class="bot_ticket_popup_body">
                        <admin-chat :ticketInfo="ticketInfo"></admin-chat>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
import helpChat from './help-chat.vue';

export default {
    name: 'ticket-help-chat-popup',
    props: ['ticketInfo'],
    components: {
       'admin-chat' : helpChat
    },
    data() {
        return {
        }
    },
    computed: {

    },
    mounted() {
        document.body.classList.add('body_right_scroll_remove');
    },
    methods: {
        closePopupOfTicketMethod() {
            bus.$emit('botTicketsChatPopupBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        }
    }
}
</script>

<style lang="scss" scoped>
.ticket_help_chat_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    height: 100dvh;
    overflow-y: auto;

    .bot_ticket_popup {
        display: table;
        width: 100%;
        height: 100%;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        @media only screen and (max-width:767px) {
            overflow-y: auto;
        }

        .bot_ticket_popup_center {
            display: table-cell;
            vertical-align: middle;
        }

        .bot_ticket_popup_modal {
            background: #000;
            max-width: 640px;
            margin: 0 auto;
            border-radius: 5px;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.1);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.1);
        }

        .bot_ticket_popup_body {
            padding: 0px;
        }

    }
}
</style>